
import instance from "../Interceptor";
import headers from "../Utils/headers";

export const fetchProductDetails = async (id, coordinates) => {
    const response = await instance(`
    ${process.env.REACT_APP_SERVER_API}/public/${id}/summary?lat=${coordinates?.lat}&lng=${coordinates?.lng}`, {
        method: "GET",
        headers
    });
    return response;
}

export const verifyUserIdentity = async (username, code) => {
    const response = await instance(`
    ${process.env.REACT_APP_SERVER_API}/public/verifyUser?username=${username}&code=${code}`, {
        method: "GET",
        headers
    });
    return response;
}

export const getStoreData = async (storeId) => {
    const response = await instance(`
    ${process.env.REACT_APP_SERVER_API}/public/store/${storeId}`, {
        method: "GET",
        headers
    });
    return response;
}

export const returnToStore = async (body) => {
    const response = await instance(`
    ${process.env.REACT_APP_SERVER_API}/public/return/store`, {
        method: "POST",
        data: body,
        headers
    });
    return response;
}

export const registerUser = async (body) => {
    const response = await instance(`
    ${process.env.REACT_APP_SERVER_API}/register`, {
        method: "POST",
        data: body,
        headers
    });
    return response;
}

export const registerOnesignalUser = async (body) => {
    const response = await instance(`
    ${process.env.REACT_APP_SERVER_API}/users/notification`, {
        method: "POST",
        data: body,
        headers
    });
    return response;
}

export const getHomeData = async () => {
    const response = await instance(`
    ${process.env.REACT_APP_SERVER_API}/users/home`, {
        method: "GET",
        headers
    });
    return response;
}

export const getCardData = async () => {
    const response = await instance(`
    ${process.env.REACT_APP_SERVER_API}/users/cards`, {
        method: "GET",
        headers
    });
    return response;
}

export const removeCardData = async (id) => {
    const response = await instance(`
    ${process.env.REACT_APP_SERVER_API}/users/cards/${id}`, {
        method: "DELETE",
        headers
    });
    return response;
}

export const saveCardToken = async (data) => {
    const response = await instance(`
    ${process.env.REACT_APP_SERVER_API}/users/cards`, {
        method: "POST",
        data,
        headers
    });
    return response;
}

export const payForExtension = async (borrowId) => {
    const response = await instance(`
    ${process.env.REACT_APP_SERVER_API}/productBorrows/${borrowId}/extend`, {
        method: "PATCH",
        headers
    });
    return response;
}

export const saveUserNameData = async (name) => {
    const response = await instance(`
    ${process.env.REACT_APP_SERVER_API}/users/update`, {
        method: "POST",
        data: { name },
        headers
    });
    return response;
}

export const saveUserEmail = async (data) => {
    const response = await instance(`
    ${process.env.REACT_APP_SERVER_API}/public/notify/email`, {
        method: "POST",
        data,
    });
    return response;
}

export const forgotPin = async (phoneNumber) => {
    const response = await instance(`
    ${process.env.REACT_APP_SERVER_API}/public/forgot-pin?phoneNumber=${phoneNumber}`, {
        method: "GET",
        headers
    });
    return response;
}
